import React, {useEffect} from "react";
import {createSearchParams, generatePath, useNavigate, useParams, useSearchParams} from "react-router-dom";
import {Card, Col, Row, Spin, Image} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {fetchGamesListAction, ROUTE_PATH, selectStore} from "../../../utils";
import {MyText} from "../../../components";
import {LeftOutlined} from "@ant-design/icons";
import {ButtonContainer} from "../style.ts";
import { useTranslation } from "react-i18next";
import { useEmbeddedNavigate } from "../../../utils/context/embed/useEmbed.ts";
import { Helmet } from "react-helmet";

export const GameCategory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const [searchParams] = useSearchParams();
  const {t} = useTranslation("common")

  const age = searchParams.get("age");
  const type = searchParams.get("type");
  const selectedMaterial = searchParams.get("selectedMaterial");

  const {gameCategory} = useParams();
  let fromAge = "";
  let toAge = "";

  if (age) {
    [fromAge, toAge] = age.split('-');
  }

  const {materials: {gamesList: gamesListState}} = useSelector(selectStore)

  useEffect(() => {
    if(gameCategory && age){
      dispatch(fetchGamesListAction({
        category: gameCategory,
        fromAge,
        toAge
      }))
    }
  }, [gameCategory])

  const handleSelectGame = (id: any) => {
    const path = {
      pathname: generatePath(ROUTE_PATH.CURRENT_GAME, {gameCategory, age: age, selectedMaterial: selectedMaterial, currentGame: id}),

    }

    embeddedNavigate(path)
  }

  const handleGoBack = () => {
    const backUrl = `/materials/detail?age=${age}&type=${type}&id=${selectedMaterial}`;
    embeddedNavigate(backUrl);
  }


  return (
    <>
    <Helmet>
      <title>
        Развивающие игры для детей раннего и дошкольного возраста – логика, внимание, память, подготовка к школе
      </title>
      <meta
        name="description"
        content="Онлайн-игры для детей раннего и дошкольного возраста: развитие логики, памяти, внимания и мышления. Игры, которые помогают родителям и педагогам в обучении и подготовке к школе."
      />
      <meta
        name="keywords"
        content="развивающие игры, игры для детей, игры для дошкольников, игры для малышей, логика, внимание, память, математика, подготовка к школе, развитие ребёнка"
      />
    </Helmet>

    <Row justify="center">
      <Col span={20}>
        <Row align="middle" style={{marginBottom: 26}}>
          <ButtonContainer onClick={handleGoBack}>
            <LeftOutlined style={{color: 'rgba(10, 3, 60, 0.7)'}}/>
          </ButtonContainer>
          <MyText color='rgba(19, 15, 38, 1)' size={32} weight={800}
                  style={{fontFamily: 'Nunito', display: 'block', marginLeft: 12}}>
            {t("gameList")}
          </MyText>
        </Row>
        <Card>
          <Spin spinning={gamesListState?.loading}>
            <Row gutter={[24, 24]}>
            {gamesListState?.data?.length ? (
                gamesListState.data.map((oneGame: any) => (
                  <Col
                    key={oneGame.id + "-game-category"}
                    xs={24}
                    sm={12}
                    md={8}
                    lg={8}
                    xl={8}
                  >
                    <Card
                      bordered
                      hoverable
                      onClick={() => handleSelectGame(oneGame.id)}
                      style={{
                        height: '300px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                      }}
                    >
                      <Row justify="center">
                        <Image
                          style={{
                            width: '100%',
                            height: '180px',
                            objectFit: 'cover',
                            borderRadius: 8,
                          }}
                          preview={false}
                          src={oneGame.iconImage}
                        />
                      </Row>
                      <Col style={{ marginTop: 26 }}>
                        <MyText weight={700} size={18}>
                          {oneGame.title}
                        </MyText>
                      </Col>
                    </Card>
                  </Col>
                ))
              ) : (
                // <MyText
                //   color="rgba(19, 15, 38, 1)"
                //   size={24}
                //   weight={800}
                //   style={{ fontFamily: 'Nunito', display: 'block' }}
                // >
                //   {t("noFound")}
                // </MyText>
                <></>
              )}
            </Row>
          </Spin>
        </Card>
      </Col>
    </Row>

    </>
  )
}